var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99997 0C7.75978 0 10 2.24029 10 5.00002C10 6.43713 9.28298 7.91639 8.38269 9.15852C7.12561 10.8932 5.55355 12.1581 5.55355 12.1581V12.1584C5.23035 12.4183 4.76965 12.4183 4.44645 12.1584V12.1581C4.44645 12.1581 2.87434 10.8933 1.61731 9.15852C0.717016 7.91639 0 6.43728 0 5.00002C0 2.24022 2.24029 0 5.00003 0H4.99997ZM4.99997 2.94132C3.86383 2.94132 2.94107 3.86398 2.94107 5.00013C2.94107 6.13637 3.86383 7.05903 4.99997 7.05903C6.13612 7.05903 7.05888 6.13637 7.05888 5.00013C7.05888 3.86398 6.13612 2.94132 4.99997 2.94132Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cfb42c39c76f5d472f864bc09244ee64.svg";
export { ForwardRef as ReactComponent };